import React from 'react';
import PropTypes from 'prop-types';
import { checkSetState } from '@teammo/teammo-general-utils';

// Components
import { Card } from 'reactstrap';
import Tbody from 'app/components/general/Tbody';
import PaymentCollectionRow from '../PaymentCollectionRow';

// Misc

export default class PaymentCollectionList extends React.Component {
  static propTypes = {
    currentPayment: PropTypes.object,
    paymentCollectionsById: PropTypes.object,
    paymentCollectionIds: PropTypes.array,
    teamMembers: PropTypes.object,
  };

  static defaultProps = {
    currentPayment: undefined,
    paymentCollectionsById: undefined,
    paymentCollectionIds: undefined,
    teamMembers: undefined,
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(checkSetState(this.props, newProps));
  }

  renderPaymentCollectionRow(paymentCollectionId) {
    if (
      this.props.paymentCollectionsById !== undefined
      && this.props.teamMembers.teamMembersById !== undefined
    ) {
      const paymentCollection = this.props.paymentCollectionsById[
        paymentCollectionId
      ];
      return (
        <PaymentCollectionRow
          key={paymentCollectionId}
          paymentCollection={paymentCollection}
          updatePaymentCollection={this.props.actions.updatePaymentCollection}
          isLoading={this.props.paymentCollections.isLoading}
          payment={paymentCollection.payment}
          amount={paymentCollection.amount}
          teamMember={
            this.props.teamMembers.teamMembersById[
              paymentCollection.teamMemberId
            ]
          }
          status={paymentCollection.status}
          purchasedAt={paymentCollection.purchasedAt}
        />
      );
    }
    return null;
  }

  renderPaymentCollectionList = (): React.ReactNode => {
    if (this.props.paymentCollectionIds !== undefined) {
      return this.props.paymentCollectionIds.map((id) => this.renderPaymentCollectionRow(id));
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <Card className="">
        <div className="row card-title">
          <div className="col col-4 col-md-6 col-lg-8 card-title-col">
            <span>Collections</span>
          </div>
          <div className="col col-8 col-md-6 col-lg-4 btn-flex-group" />
        </div>
        <div className="row head-row">
          <div className="col col-3">Team Member</div>
          <div className="col col-2">Amount</div>
          <div className="col col-3">Status</div>
          <div className="col col-2 col-3-sm">Date Paid</div>
          <div className="col col-2 col-1-sm" />
        </div>
        <Tbody name="payments">{this.renderPaymentCollectionList()}</Tbody>
      </Card>
    );
  }
}
